// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__3ou7c","footer":"ChangeClinic_footer__1-dSO"};